(function () {
  'use strict';

  function setup(root, cfg) {
    var viewport = root.querySelector(cfg.viewport);
    var track = root.querySelector(cfg.track);
    var items = track ? track.querySelectorAll(cfg.item) : [];
    var indicator = root.querySelector(cfg.indicator);
    if (!viewport || !track || !indicator || items.length < 2) return;
    if (indicator.dataset.ready === '1') return;
    indicator.dataset.ready = '1';

    // Track is rendered triplicated (3x) for seamless wrap on both sides.
    var copies = 3;
    var unique = Math.max(1, Math.floor(items.length / copies));
    var dots = [];
    var current = 0;
    var paused = false;

    for (var i = 0; i < unique; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'marquee-dot';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', 'スライド ' + (i + 1));
      btn.dataset.index = String(i);
      btn.addEventListener('click', onClick);
      indicator.appendChild(btn);
      dots.push(btn);
    }

    function onClick(e) {
      var idx = parseInt(e.currentTarget.dataset.index, 10);
      goTo(idx, true);
    }

    function centerOffset(itemEl) {
      if (!itemEl) return 0;
      var itemCenter = itemEl.offsetLeft + itemEl.offsetWidth / 2;
      var vpCenter = viewport.clientWidth / 2;
      return vpCenter - itemCenter;
    }

    function goTo(idx, fromUser) {
      current = idx;
      track.style.animation = 'none';
      track.style.transition = 'transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)';
      var target = items[unique + idx] || items[idx];
      track.style.transform = 'translate3d(' + centerOffset(target) + 'px, 0, 0)';
      paused = !!fromUser;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    }

    // Track which dot represents the slide currently centered in viewport while auto-scrolling.
    function updateActiveFromScroll() {
      if (paused) return;
      var rect = viewport.getBoundingClientRect();
      var centerX = rect.left + rect.width / 2;
      var bestLogical = 0;
      var bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - centerX);
        if (d < bestDist) { bestDist = d; bestLogical = i % unique; }
      }
      if (bestLogical !== current) {
        current = bestLogical;
        dots.forEach(function (dot, k) { dot.classList.toggle('is-active', k === bestLogical); });
      }
    }

    dots[0].classList.add('is-active');

    var raf;
    function loop() {
      updateActiveFromScroll();
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);

    // Pause loop when off-screen to save CPU
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!raf) raf = requestAnimationFrame(loop);
          } else if (raf) {
            cancelAnimationFrame(raf);
            raf = null;
          }
        });
      }, { threshold: 0 }).observe(root);
    }
  }

  function initAll() {
    document.querySelectorAll('.p-marquee').forEach(function (el) {
      setup(el, {
        viewport: '.p-marquee__viewport',
        track: '.p-marquee__track',
        item: '.p-marquee__item',
        indicator: '.p-marquee__indicator'
      });
    });
    document.querySelectorAll('.p-features-marquee').forEach(function (el) {
      setup(el, {
        viewport: '.p-features-marquee__viewport',
        track: '.p-features-marquee__track',
        item: '.p-features-marquee__card',
        indicator: '.p-features-marquee__indicator'
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
